import type { RouteRecordRaw } from 'vue-router'

import { registerDataConnectorMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

export const dataConnectorRoutes: RouteRecordRaw[] = [
  {
    path: 'tools/data-connectors',
    name: 'DataConnectors',
    component: () => import('./components/DataConnectorsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'ad_metric_integrator',
      navKey: 'dataConnectors',
      titleKey: 'dataConnectors.page.title',
      contentInset: 'tight',
    },
    beforeEnter: () => registerDataConnectorMessages(useLocaleStore().locale),
  },
]
